import { Calendar, List } from "lucide-react";
import { cn } from "@/lib/utils";

type ViewMode = "grouped" | "list";

interface ViewToggleProps {
  view: ViewMode;
  onChange: (view: ViewMode) => void;
  byDayLabel: string;
  listLabel: string;
}

export default function ViewToggle({ view, onChange, byDayLabel, listLabel }: ViewToggleProps) {
  return (
    <div
      className="inline-flex gap-[2px] rounded-[10px] border border-[var(--border-color)] bg-[var(--bg-secondary)] p-[3px]"
      role="tablist"
      aria-label="View"
    >
      <button
        type="button"
        role="tab"
        aria-selected={view === "grouped"}
        className={cn(
          "inline-flex items-center gap-1.5 rounded-[7px] px-[14px] py-[6px] text-[12px] font-normal text-[var(--text-secondary)] transition-all [transition-duration:150ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)]",
          view === "grouped" && "bg-[var(--bg-hover)] text-[var(--text-primary)] shadow-[0_1px_2px_rgba(0,0,0,0.2)]",
        )}
        onClick={() => onChange("grouped")}
      >
        <Calendar size={13} />
        {byDayLabel}
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={view === "list"}
        className={cn(
          "inline-flex items-center gap-1.5 rounded-[7px] px-[14px] py-[6px] text-[12px] font-normal text-[var(--text-secondary)] transition-all [transition-duration:150ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)]",
          view === "list" && "bg-[var(--bg-hover)] text-[var(--text-primary)] shadow-[0_1px_2px_rgba(0,0,0,0.2)]",
        )}
        onClick={() => onChange("list")}
      >
        <List size={13} />
        {listLabel}
      </button>
    </div>
  );
}
